import { render } from "./AtendimentoConvenioRelatorio.vue?vue&type=template&id=a16d957a&scoped=true"
import script from "./AtendimentoConvenioRelatorio.vue?vue&type=script&lang=js"
export * from "./AtendimentoConvenioRelatorio.vue?vue&type=script&lang=js"

import "./AtendimentoConvenioRelatorio.vue?vue&type=style&index=0&id=a16d957a&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a16d957a"]])

export default __exports__